<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upsell Settings'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="settingsForm">
    <tidy-wrapper>
      <ng-container>
        <tidy-card>
          <tidy-row>
            <tidy-textarea
              [label]="'Early Check-In Instructions'"
              formControlName="earlyCheckInInstructions"
              [form]="settingsForm.controls.earlyCheckInInstructions"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Early check-in instructions are required'"
              [placeholder]="'Default instructions for handling early check-in requests'" />
          </tidy-row>

          <tidy-row>
            <tidy-textarea
              [label]="'Late Check-Out Instructions'"
              formControlName="lateCheckOutInstructions"
              [form]="settingsForm.controls.lateCheckOutInstructions"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Late check-out instructions are required'"
              [placeholder]="'Default instructions for handling late check-out requests'" />
          </tidy-row>

          <tidy-row>
            <tidy-textarea
              [label]="'Mid-Stay Clean Instructions'"
              formControlName="midStayCleanInstructions"
              [form]="settingsForm.controls.midStayCleanInstructions"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Mid-stay clean instructions are required'"
              [placeholder]="'Default instructions for handling mid-stay clean requests'" />
          </tidy-row>
        </tidy-card>

        <tidy-row [align]="'center'">
          <tidy-button
            [text]="'Save Settings'"
            [action]="boundSaveSettings"
            class="primary" />
        </tidy-row>

        <tidy-error-message [text]="errorMessage" />
      </ng-container>
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content>
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
